import {eventType, hitType} from "../../analytics.helper";
import {historyInfoActionTypes} from "../../../../_constants";

// EVENTS ##########################################################

// page-view : action has location details
const pageView = (action) => {
	const {pathname, search} = action.location;
	return {
		event: eventType.PAGE_VIEW,
		hitType: hitType.EVENT,
		values: {
			page: pathname,               // url path
			pageQuery: search,            // url query
			pageTitle: pathname + search, // url path + query
		}
	};
};

// EVENT-MAPPINGS ##########################################################

// page events mappings
export const pageEventsMap = {
	[historyInfoActionTypes.PUSH] : pageView,
	[historyInfoActionTypes.POP]  : pageView,
};